import React from "react";
import { Rate } from "antd";
import ShowMoreArrow from "../../files/components/showMoreArrow.js";
import ShowLessArrow from "../../files/components/showLessArrow.js";
import styles from "./feedback.module.css";

class OneFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCollapsed: true
    };

    this.handleShrink = this.handleShrink.bind(this);
  }

  handleShrink() {
    this.setState({ isCollapsed: !this.state.isCollapsed })
  }

  render() {
    const feedback = this.props.feedback;

    return (
      <div className={styles.slideContainer} id={this.props.feedback.id}>
        <div
          style={{
            //minHeight: "11.1em", 
            marginLeft: "1.7%"
          }}
        >

          <div className={styles.contentContainer} >
            <div style={{ display: "flex" }}>
              <div
                className={styles.quotaContainer}
                style={{
                  alignSelf: "flex-start",
                  display: "flex",
                  justifyContent: "center",
                  position: "relative"
                }}
              >
                <span style={{ position: "absolute", top: "0" }}>«</span>
              </div>
              <div style={{ flex: "10", paddingTop: "1em", fontSize: "0.9vw", position: "relative" }}>
                <div className={
                  this.state.isCollapsed ? styles.textContainer : styles.textContainerFull
                  //styles.textContainer
                }>
                  <div style={{ textAlign: "center" }}>
                    <img src={feedback.photo} className={styles.avatar} />
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: feedback.text }} style={{ display: "inline" }} />
                </div>
              </div>
              <div
                className={styles.quotaContainer}
                style={{
                  alignSelf: "flex-end",
                  position: "relative"
                }}
              >
                <span style={{ position: "absolute", bottom: "0", left: "0.5em" }}>»</span>
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", paddingTop: "0.5em", fontSize: "0.9vw", paddingLeft: "0.6em" }}>
          <div style={{ flex: "1" }} />
          <div style={{ flex: "10" }}>
            <div style={{ display: "flex" }}>
              <div style={{ flex: "10" }}>
                <div className={styles.scoreContainer}>
                  <Rate
                    disabled
                    defaultValue={feedback.score}
                    style={{ color: "#fca25c" }}
                  />
                </div>
                <div style={{ fontWeight: "600" }}>
                  <span>{feedback.name}</span> <span>—</span>{" "}
                  <span>{feedback.occupation}</span>
                </div>
              </div>
              <div style={{ flex: "0" }} />
            </div>
          </div>
        </div>

        <div style={{ display: "flex", paddingTop: "0.15em", paddingLeft: "0.2em" }}>
          <div style={{ flex: "10" }}>
            <div style={{ display: "flex", position: "relative" }}>
              <div style={{ flex: "1" }} >
                <div className={styles.theButton}>
                  <div className={styles.showMoreButton} >
                    <div className="arrowContainer" onClick={this.handleShrink}>
                      <div style={{display: this.state.isCollapsed ? "initial" : "none"}}><ShowMoreArrow /></div>
                      <div style={{display: this.state.isCollapsed ? "none" : "initial"}}><ShowLessArrow /></div>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ flex: "0" }} />
            </div>
          </div>
        </div>
      </div>
    );
  }


}

export default OneFeedback;
